<template>
  <unauthorised v-if="$zvdzRoute.meta.mustBeLoggedIn" />
  <the-navigation v-else-if="$zvdzRoute.meta.showNavigation">
    <router-view />
  </the-navigation>
  <router-view v-else />
</template>

<script lang="ts" setup>
import Unauthorised from '@/router/Unauthorised.vue';
import TheNavigation from '@/areas/skeleton/views/TheNavigation.vue';
</script>
